"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "rivodutri": {
    "efdcb26c": [{
      "hkey": "5ac6ed86",
      "slug": "rivodutri",
      "name": "Rivodutri",
      "primary": true,
      "skipSearch": false
    }],
    "cerqueto": [{
      "hkey": "5ac6ed86",
      "slug": "rivodutri",
      "name": "Rivodutri",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f2aa1b1b": [{
      "hkey": "5ac6ed86",
      "slug": "rivodutri",
      "name": "Rivodutri",
      "primary": true,
      "skipSearch": false
    }],
    "mezzo-piedi": [{
      "hkey": "5ac6ed86",
      "slug": "rivodutri",
      "name": "Rivodutri",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "24c031eb": [{
      "hkey": "5ac6ed86",
      "slug": "rivodutri",
      "name": "Rivodutri",
      "primary": true,
      "skipSearch": false
    }],
    "pretaro": [{
      "hkey": "5ac6ed86",
      "slug": "rivodutri",
      "name": "Rivodutri",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "9a55fb1a": [{
      "hkey": "2beac8da",
      "slug": "villaggio-santa-maria",
      "name": "Villaggio Santa Maria",
      "primary": true,
      "skipSearch": false
    }],
    "santa-maria": [{
      "hkey": "2beac8da",
      "slug": "villaggio-santa-maria",
      "name": "Villaggio Santa Maria",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "rivodutri"
    }],
    "1eb62636": [{
      "hkey": "5ac6ed86",
      "slug": "rivodutri",
      "name": "Rivodutri",
      "primary": true,
      "skipSearch": false
    }],
    "vignaletto": [{
      "hkey": "5ac6ed86",
      "slug": "rivodutri",
      "name": "Rivodutri",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;